/********** LOGIN **********/

export const GET_AUTH_USER = "GET_AUTH_USER"
export const GET_AUTH_USER_OK = "GET_AUTH_USER_OK"
export const GET_AUTH_USER_ERR = "GET_AUTH_USER_ERR"